import { Card, Stack, Typography } from '@mui/material';
import React from 'react';
import { RocketIcon } from '../../Components/Icons/Icons';
import { AppColors } from '../../Utils/helper/AppColors';

export default function ComingSoon() {
	return (
		<Stack sx={{ padding: 2 }} alignItems="center" justifyContent="center" height="100vh">
			<Card sx={{ width: { xs: '90vw', md: 400 } }}>
				<Stack p={2} alignItems="center" justifyContent="center" gap={1}>
					<RocketIcon size={140} color={AppColors.PRIMARY_DARK} />
					<Typography fontSize={34}>Coming Soon</Typography>
					<Typography textAlign="center" fontWeight={400} fontSize={16} color={AppColors.TEXT_SECONDARY}>
						This feature is designed to enhance your experience. Stay tuned for updates.
					</Typography>
				</Stack>
			</Card>
		</Stack>
	);
}
